import React, { useEffect, useState, useRef } from "react"
import {    Row,Col,Modal,ModalBody,} from "reactstrap"
 import { AvForm,} from 'availity-reactstrap-validation'
import { toast } from "react-toastify" 
import BaseService from "services/BaseService"
import { salesDeveloperPrefix } from "configs/routePrefix"
import { useDispatch,useSelector } from "react-redux"
import { appendData } from "store/Mode/actions"
import "../style.scss"
import DeleteModal from "components/Common/DeleteModal"
import axios from "axios"
import InterActiveModeService from "services/SalesDeveloper/InterActiveModeService"
import CropImg from "./CropImg"


function ModalForm({ modal, toggle,item, history, editMode, deleteInteractive, setShouldGetData,from, compoundOptions, setCompoundOptions ,setUpdateOptions }) {
    const interActiveModeService = new InterActiveModeService()
    const [images, setImages] = useState([])
    const [deleteModal, setDeleteModal] = useState(false)
    const [cropModal, setCropModal] = useState(false)
    const [openLibrary, setOpenLibrary] = useState(false)
    const [loading, setLoading] = useState(false)
    const [percent, setPercent] = useState(0)
    const cancelTokenSource = useRef()
    const dispatch = useDispatch()
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => AuthData.permissions[data]
    const [modeData, setModeData] = useState({
        compound: null,
        image: null
    })

    useEffect(() => {
        if (editMode ?.id) {
            setModeData({
                ...modeData,
                id: editMode ?.id,
                compound: {
                    value: editMode ?.compound.id,
                    label: editMode ?.compound.name.en
                },
                image: {
                    id: editMode ?.main_image.id,
                    path: editMode ?.main_image.path
                }
            })
        }
    }, [editMode])

    const addImagesHandler = (e) => {
        setLoading(true)
        let files = e.target.files
        const filesData = Object.values(files)
        const uploadedImgs = []
        cancelTokenSource.current = axios.CancelToken.source()
        const options = {
            cancelToken: cancelTokenSource.current.token,
            ignoreInterceptors: true,
            onUploadProgress: (progressEvent) => {
                const { loaded, total } = progressEvent
                let percentValue = (loaded * 100) / total
                setPercent((p) => percentValue > p ? percentValue : p)
            }
        }
        if (filesData.length) {
            filesData.map(async (file) => {
                new BaseService().postUpload(file, options).then(res => {
                    setPercent(0)
                    const createdFiles = { ...res.data.data, shapes: [] }
                    uploadedImgs.push(createdFiles)
                    setModeData({ ...modeData, image: uploadedImgs[0] })
                }).catch((err) => { })
            })
        }
    }

    useEffect(() => {
        if (modeData.compound) {
            setImages(modeData.compound.images)
        }
    }, [modeData.compound])

    const handleCloseModal = (action, response) => {
        if (action === "delete") {
            setDeleteModal(false)
            setShouldGetData(true)
            setUpdateOptions(true)
            toggle()
        } else {
            setDeleteModal(false)
        }
    }

    useEffect(() => {
             return ()=>cancelTokenSource?.current?.cancel()
    }, [])

    const submitHandler=() => {
        if (!editMode) {
            if (!modeData.image) {
                toast.error("Please, Select Image")
                return
            } else {
                dispatch(appendData({
                    compound: {
                        id: item.id,
                        value: item.id,
                        label: item.name.en
                    },
                    currentImge: modeData.image,
                    masterImg: modeData.image,
                    from: from,
                    images: [{
                        ...modeData.image
                    }]
                }
                ))
                history.push(`${salesDeveloperPrefix}/add-mode`)
                toggle()
            }
        } else {
            interActiveModeService.find(modeData.id).then(res => {
                const master=res.data.images.find(item=>item.image.id===res.data.main_image.id)
                 dispatch(appendData({
                    type: "edit",
                    editId: modeData.id,
                    compound: modeData.compound,
                    from: from,
                    currentImge: {
                        id: master?.image?.id,
                        path: master?.image?.path
                    },
                    masterImg: {
                        id: master?.image?.id,
                        path: master?.image.path
                    },
                    images: res.data.images.map(img => ({
                        ...img,
                        ...img.image,
                        image: null,
                        shapes:img.shapes==="" ? []:img.shapes

                    }))
                }
                ))
                setTimeout(() => {
                    history?.push(`${salesDeveloperPrefix}/add-mode`)
                    toggle()
                }, 1000)

            })
        }
    }
    const toggleCrop = () => setCropModal(!modal);
    const [fileName, setFileName] = useState(null)
    const [image, setImage] = useState("");

    const onImageSelected = (e) => {
        const reader = new FileReader();
        setFileName(e.target.files[0])
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (e) {
            setImage(reader.result);
            setCropModal(true);
        };
    }

    return (
        <>
            <AvForm
                className='form-horizontal'
                onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                }}>
                <Modal isOpen={modal} className="scrollbar-container mt-5 ineractive-modal">
                    <ModalBody>
                        <Row className="mb-1">
                            <Col md={8} className="font-size-18 fw-bold">{!editMode ? "Add New Interactive Mode" : "Edit Interactive Mode"}</Col>
                            <Col className="d-flex justify-content-end font-size-14 fw-bold btn-hover mt-1" md={4}><span onClick={() => {
                                if (loading) {
                                    cancelTokenSource.current.cancel()
                                }
                                toggle()
                            }} className="fw-bold font-size-14">X</span></Col>
                        </Row>
                        <hr className="mt-1 mb-4" />
                        <Row >
                            <Col>
                                {percent > 0 ?
                                    <div className="progress mb-1">
                                        <div
                                            className="progress-bar progress-bar-striped"
                                            role="progressbar"
                                            style={{ width: percent + '%' }}
                                            aria-valuenow={`${percent}`}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        >
                                        </div>
                                    </div> : <div  ></div>}
                            </Col>
                            <Col md={12} className="parent-div my-1" >
                                {modeData ?.image ?.path ?
                                    <>
                                        <img className="position-relative" src={modeData ?.image ?.path} style={{ width: "100%", height: "180px", objectFit: "cover", borderRadius: "10px" }}  >
                                        </img>
                                        <button
                                            className="position-absolute overflow-hidden text-danger fw-bold p-1 font-size-16"
                                            onClick={() => {
                                                setModeData({ ...modeData, image: null })
                                                setOpenLibrary(false)
                                            }}
                                            style={{ top: "5px", right: "15px", border: "none", background: "white", borderRadius: "15px", height: "30px", width: "30px", paddingRight: "20px", paddingTop: "5px" }}
                                        >
                                            x
                                    </button>
                                        {!openLibrary ? <button
                                            className="position-absolute overflow-hidden"
                                            style={{ bottom: "5px", right: "15px", border: "none", background: "white", borderRadius: "19px", height: "38px", width: "38px", paddingRight: "20px", paddingTop: "5px" }}
                                        ><i className="fas fa-pen  overflow-hidden text-success p-2 "
                                        >
                                            </i>
                                            <input type="file" name="upfile" accept="image/*" onChange={onImageSelected} />
                                        </button> : null}
                                    </> : null}
                            </Col>
                            {!modeData ?.image ?.path && !openLibrary ?
                                <Col md={12} className="parent-div my-1" >
                                    <div className="p-2 bg-light " style={{ borderRadius: "10px" }} >
                                        <div
                                            className="px-4 w-100 btn-upload  font-size-16 py-4 "
                                            style={{ border: "2px #cadff7 dashed", height: "150px", background: "#F3F3F9", borderRadius: "10px" }}>
                                            <div
                                                style={{ width: "50px", height: "50px",margin:"auto", background: "white", borderRadius: "25px"}}>
                                                <i className="fas fa-cloud-upload-alt text-success " style={{padding:"16px"}}>
                                                </i>
                                            </div>
                                            <div className="m-auto text-center">
                                                <span className="m-auto " >Click to upload or drag and drop</span>
                                                </div>
                                            <div
                                               className="m-auto text-left text-primary fw-bold btn-hover"
                                                 >
                                               <span  style={{marginLeft:"69px",textDecoration:"underline"}} >from computer</span>
                                            </div>
                                        </div>
                                        <span className="or-btn">or</span>
                                        <p className="library-btn font-size-16 text-primary fw-bold "
                                            onClick={(e) => {
                                                if (modeData.compound) {
                                                    if (images.length === 0) {
                                                        toast.error("Compound hasn't an images")
                                                    } else {
                                                        setOpenLibrary(true)
                                                    }

                                                } else {
                                                    toast.error("Please Select Compound")
                                                }
                                            }}>from library</p>
                                        <input type="file"   name="upfile" className="btn-hover" accept="image/*" onChange={onImageSelected} />
                                    </div>
                                </Col> : null }
                            {!modeData ?.image ?.path && openLibrary ? <Col className="d-flex flex-wrap parent-div">
                                {images.length > 0 ? images ?.map(item => {
                                    return (
                                        <div key={item.id} className="mx-1 my-2 d-flex"
                                            style={{ width: "80px", height: "70px", border: modeData ?.image ?.id === item.id ? "2px solid black" : "none" }}
                                            onClick={() => setModeData({ ...modeData, image: { ...item, shapes: [] } })}>
                                            <img src={item.path} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                        </div>
                                    )
                                }) : null}
                            </Col> : null }

                        </Row>

                    </ModalBody>
                    <Row className="p-0 pt-1 m-0 mt-2 d-flex justify-content-between">
                        <Col md={6}>
                            {isExist("add_compound") && editMode ?.id  ? <button
                                type='button'
                                onClick={() => setDeleteModal(true)}
                                className='btn btn-danger w-50'>
                                Delete
                        </button> : null}
                        {!editMode ?.id ? <button
                                type='button'
                                onClick={toggle}
                                className='btn btn-secondary w-50'>
                                Cancel
                        </button>:null}
                        </Col>
                         {isExist("add_compound") && editMode ? <Col md={6} className=" d-flex justify-content-end">
                            <button
                                type='button'
                                onClick={submitHandler}
                                disabled={ percent === 0 ? false : percent === 100 ? false : true}
                                className='btn btn-success w-50'>
                                Edit
                            </button>
                        </Col> :null} 
                        {isExist("add_compound") && !editMode ? <Col md={6} className=" d-flex justify-content-end">
                            <button
                                type='button'
                                onClick={submitHandler}
                                disabled={ percent === 0 ? false : percent === 100 ? false : true}
                                className='btn btn-success w-50'>
                               Next
                            </button>
                        </Col>:null}
                    </Row>
                </Modal>
            </AvForm>
            <DeleteModal
                open={deleteModal}
                titleMsg={deleteInteractive ?.compound ?.label}
                deletedItem={editMode}
                modelService={interActiveModeService}
                onCloseModal={(action) => handleCloseModal(action)}
            />
            {cropModal && <CropImg
                modal={cropModal}
                toggle={toggleCrop}
                img={image}
                setModeData={setModeData}
                modeData ={modeData}
                fileName={fileName}
            />}
        </>

    )
}

export default ModalForm
